module.exports = __webpack_public_path__ + "assets/img/08.5489fdae.png";